import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { SideBar } from '../common/sideBar'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../layout/store/slice'
// import { getIsLock } from './helper'
import './lang/i18n'

export const getListSideBar = (userType, AUTHORIZATION_API) => [
  {
    route: '/connectMap/entityMap',
    label: 'connectMap.main.ENTITY_MAP',
    // isLock: getIsLock(userType, AUTHORIZATION_API.connectMap.entityMap),
  },
  {
    route: '/connectMap/interconnectionMap',
    label: 'connectMap.main.INTERCONNECTION_MAP',
    // isLock: getIsLock(
    //   userType,
    //   AUTHORIZATION_API.connectMap.interconnectionMap,
    // ),
  },
]

export const LayoutConnectMap = ({
  renderTopComponent,
  renderBottomComponent,
}) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  return (
    <SideBar
      list={getListSideBar(userType, AUTHORIZATION_API)}
      renderTopComponent={renderTopComponent}
      renderBottomComponent={renderBottomComponent}
      isResponsive={false}
      isShowFooter={false}
    />
  )
}

LayoutConnectMap.propTypes = {
  renderTopComponent: PropTypes.func,
  renderBottomComponent: PropTypes.func,
}

LayoutConnectMap.defaultProps = {
  renderTopComponent: () => {},
  renderBottomComponent: () => {},
}
